import { ForecastForReceiptRouterInfo } from '@/customerForecastModule/domains/routerInfo';
import SearchForecastForReceipt from './pages/SearchForecastForReceipt.vue';
import BusinessListForecastForReceipt from './pages/BusinessListForecastForReceipt.vue';
import ForecastAccuracy from './pages/ForecastAccuracy.vue';
import CustomerForecastDiffLastMonth from './pages/CustomerForecastDiffLastMonth.vue';
import CustomerForecastTimeline from './pages/CustomerForecastTimeline.vue';
import { i18n } from '@/i18n';
import { TableContentHeader } from '@/corePagesModule/BaseTableContent/interface/tableContentHeaders';

const t = i18n.t;

export const CUSTOMER_TAB_ROUTER_INFO: ReadonlyArray<Readonly<ForecastForReceiptRouterInfo>> = [
  {
    // ダッシュボードページ
    router: '/customer-forecast-dashboard',
    name: undefined,
    label: t('forecastForReceipt_receiveForecastSearch'),
    component: SearchForecastForReceipt,
  },
  {
    router: '/customer',
    name: undefined,
    label: t('forecastForReceipt_receiveForecastBusiness'),
    component: BusinessListForecastForReceipt,
  },
  {
    // 内示正答率ページ
    router: '/customer-forecast-accuracy',
    name: undefined,
    label: t('forecastForReceipt_forecastAccuracy'),
    component: ForecastAccuracy,
  },
  {
    // 内示前月差異ページ
    router: '/customer-forecast-difference',
    name: undefined,
    label: t('内示前月差異'),
    component: CustomerForecastDiffLastMonth,
  },
  {
    // 内示遍歴ページ
    router: '/customer-forecast-timeline',
    name: 'customer-forecast-timeline',
    label: t('内示遍歴'),
    component: CustomerForecastTimeline,
  },
  // TODO: 2024/12/14 12月時点、以下のページが未実装なため一旦非表示
  // {
  //   router: '/customer',
  //   label: t('forecastForReceipt_receiveForecastSearch'),
  //   component: SearchForecastForReceipt,
  // },
  // {
  //   router: '/customer-forecast',
  //   label: t('forecastForReceipt_receiveForecastBusiness'),
  //   component: BusinessListForecastForReceipt,
  // },
  // {
  //   router: '/forecast-accuracy',
  //   label: t('forecastForReceipt_forecastAccuracy'),
  //   component: ForecastAccuracy,
  // },
  // {
  //   router: '/forecast-unreceived',
  //   label: t('forecastForReceipt_forecastUnreceived'),
  //   component: ForecastUnreceived,
  // },
];

export const MIN_OF_DISPLAY_FORECAST_MONTH = 3;
export const MAX_OF_DISPLAY_FORECAST_MONTH = 24;
export const DEFAULT_DISPLAY_FORECAST_MONTH = 4;
export const MAX_OF_DISPLAY_FORECAST_MONTH_IN_DIFF_LAST_MONTH_PAGE = 12;

/**
 * Display months options for forecast accuracy page (3-24 months)
 * 内示正答率ページの表示月数の選択肢
 */
export const DISPLAY_MONTHS_OPTIONS = [3, 6, 9, 12, 15, 18, 21, 24] as const;

export const DEFAULT_CUSTOMER_FORECAST_TIMELINE_MONTH_COUNT = 12;
export const MIN_OF_CUSTOMER_FORECAST_TIMELINE_MONTH_COUNT = 12;
export const MAX_OF_CUSTOMER_FORECAST_TIMELINE_MONTH_COUNT = 24;

/**
 * 受領用内示メニューのドロップダウンに表示する項目（削除は編集モードに移動）
 */
export const FORECAST_FOR_RECEIPT_DROPDOWN_MENU_ITEMS = [
  'CreateForecastForReceipt',
  'AddBaseBusinessToForecastForReceipt',
  'EditForecastForReceipt',
] as const;
export const FORECAST_FOR_RECEIPT_ACTION_TYPES = [
  'none',
  'create',
  'delete',
  'updateForecastForReceipt',
  'addBaseBusiness',
  'deleteBaseBusiness',
] as const;

export const FORECAST_FOR_RECEIPT_ALL_BUSINESS_TABLE_TYPE = 'forecastForReceiptAllBusinessTable';
export const CUSTOMER_FORECAST_DIFF_LAST_MONTH_TABLE_TYPE = 'customerForecastDiffLastMonth';

/**
 * ダウンロードメニューの項目の型
 */
export type DownloadMenuItems = 'ForecastForReceiptFormat' | 'SalesResultAndCustomerForecast';

/**
 * ダウンロードメニューの項目の一覧
 */
export const DOWNLOAD_MENU_ITEMS: readonly DownloadMenuItems[] = ['ForecastForReceiptFormat', 'SalesResultAndCustomerForecast'] as const;

/**
 * 担当者絞り込みテーブルのヘッダー情報
 */
export const staffFilterTableHeaders: TableContentHeader = {
  contentProperties: [
    {
      key: 'choice',
      isVariableWidth: false,
      isNarrowable: false,
      isEditable: false,
      sortOption: { isSortable: false, isAsc: true },
      propertyPath: { paths: ['choice'], propertyType: 'string' },
    },
    {
      key: 'ForecastForReceiptStaff',
      isVariableWidth: false,
      isNarrowable: false,
      isEditable: false,
      sortOption: {
        isSortable: false,
        isAsc: true,
      },
      propertyPath: { paths: [], propertyType: 'string' },
    },
    {
      key: 'ForecastForReceiptRecoverStatus',
      isVariableWidth: false,
      isNarrowable: false,
      isEditable: false,
      sortOption: {
        isSortable: false,
        isAsc: true,
      },
      propertyPath: { paths: [], propertyType: 'string' },
      displayLabel: 'StaffFilterRecoverStatusLabel',
    },
    {
      key: 'ForecastForReceiptRecoverRate',
      isVariableWidth: false,
      isNarrowable: false,
      isEditable: false,
      sortOption: {
        isSortable: false,
        isAsc: true,
      },
      propertyPath: { paths: [], propertyType: 'string' },
    },
    {
      key: 'ForecastForReceiptLatestUpdateAt',
      isVariableWidth: false,
      isNarrowable: false,
      isEditable: false,
      sortOption: {
        isSortable: false,
        isAsc: true,
      },
      propertyPath: { paths: [], propertyType: 'string' },
    },
    {
      key: 'ForecastForReceiptEditOption',
      isVariableWidth: false,
      isNarrowable: false,
      isEditable: false,
      sortOption: {
        isSortable: false,
        isAsc: true,
      },
      propertyPath: { paths: [], propertyType: 'string' },
    },
  ],
  options: {
    stableColumnCount: 0,
    resizableHeaderColumn: false,
  },
};

/**
 * 検索結果テーブルのヘッダー情報
 */
export const searchResultTableHeaders: TableContentHeader = {
  contentProperties: [
    {
      key: 'choice',
      isVariableWidth: false,
      isNarrowable: false,
      isEditable: false,
      sortOption: { isSortable: false, isAsc: true },
      propertyPath: { paths: ['choice'], propertyType: 'string' },
    },
    {
      key: 'ForecastForReceiptStaff',
      isVariableWidth: false,
      isNarrowable: false,
      isEditable: false,
      sortOption: {
        isSortable: false,
        isAsc: true,
      },
      propertyPath: { paths: ['forecastForReceiptResponsibleUsers'], propertyType: 'string' },
    },
    {
      key: 'ForecastForReceiptName',
      isVariableWidth: false,
      isNarrowable: false,
      isEditable: false,
      sortOption: {
        isSortable: false,
        isAsc: true,
      },
      propertyPath: { paths: ['forecastForReceiptName'], propertyType: 'string' },
    },
    /*{
      key: 'ForecastForReceiptKeyword',
      isVariableWidth: false,
      isNarrowable: false,
      isEditable: false,
      sortOption: {
        isSortable: false,
        isAsc: true,
      },
      propertyPath: { paths: ['keyword'], propertyType: 'string' },
    },*/
    {
      key: 'ForecastForReceiptRecoverStatus',
      isVariableWidth: false,
      isNarrowable: false,
      isEditable: false,
      sortOption: {
        isSortable: false,
        isAsc: true,
      },
      propertyPath: { paths: [], propertyType: 'string' },
    },
    {
      key: 'ForecastForReceiptRecoverRate',
      isVariableWidth: false,
      isNarrowable: false,
      isEditable: false,
      sortOption: {
        isSortable: false,
        isAsc: true,
      },
      propertyPath: { paths: [], propertyType: 'string' },
    },
    {
      key: 'ForecastForReceiptLatestUpdateAt',
      isVariableWidth: false,
      isNarrowable: false,
      isEditable: false,
      sortOption: {
        isSortable: false,
        isAsc: true,
      },
      propertyPath: { paths: [], propertyType: 'string' },
    },
    {
      key: 'ForecastForReceiptRowMenu',
      isVariableWidth: false,
      isNarrowable: false,
      isEditable: false,
      sortOption: {
        isSortable: false,
        isAsc: true,
      },
      propertyPath: { paths: [], propertyType: 'string' },
    },
  ],
  options: {
    stableColumnCount: 0,
    resizableHeaderColumn: false,
  },
};
